import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ProfessionalTransfersModalComponent } from '../professional-transfers-modal/professional-transfers-modal.component';
import { Store } from '@ngrx/store';
import { ProfessionalTransfersReportActions } from 'src/app/store/professional-transfers-report/professional-transfers-report.actions';
import { selectProfessionalTransfersReport } from 'src/app/store/professional-transfers-report/professional-transfers-report.selectors';
import { IProfessionalTransfersReport } from 'src/app/shared/interfaces/professional-transfers-report/iprofessionaltransfersreport';
import { ProfessionalTransfersService } from 'src/app/shared/services/professional-transfers.service';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { Filter } from 'src/app/shared/models/filter';
import { DatePipe } from '@angular/common';
import { FormatDateUtil } from 'src/app/shared/utils/format-date-util';

@Component({
  selector: 'app-professional-transfers-report',
  templateUrl: './professional-transfers-report.component.html',
  styleUrls: ['./professional-transfers-report.component.scss']
})
export class ProfessionalTransfersReportComponent implements OnInit {
  showChart = false
  showProfessionalList = false
  filterOption: any
  form = this.fb.group({
    faturamento_total: [''],
    receita_profissional: [''],
    receita_empresa: [''],
    valor_a_pagar_empresa: [''],
    chart_data: [[
      {
        legend: '',
        data: [0],
        gradientColors: ['']
      }

    ]],
    chart_label: [['']],
    listagem_profissionais: [[
      {
        posicao_ranking: 0,
        nome: '',
        atendimentos: '',
        split: false,
        valor_total: '',
        valor_para_profissional: '',
        porcentagem_profissional: "",
        valor_ideal_profissional_porcentagem: '',
        valor_ideal_empresa_porcentagem: '',
        valor_empresa: '',
        porcentagem_empresa: '',
        valor_pendente: '',
        comparativo_receita_mes_ant_porcento: '',
        relatorio_atendimentos: [
          {
            data: '',
            paciente: '',
            servico: '',
            valor_total: '',
            centro: '',
            especialista: ''
          }
        ]
      }
    ]],
    total_listagem_profissionais: [{} as any],

  });



  public filter = new Filter();

  public subtitle: string = '';

  public loadingProfessionals: boolean = true;
  public loadingTotalAmount: boolean = true;
  protected loadingChart: boolean = false;

  data$ = this.store.select(selectProfessionalTransfersReport)

  constructor(
    private fb: FormBuilder,
    public modalService: ModalService,
    private store: Store,
    private professionalTransfersService: ProfessionalTransfersService,
    private notify: NotifyService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
  }

  addFilterOptions(event: any) {
    this.loadingTotalAmount = true;
    console.log(event);

     let {year, month} = event.period;
    if(event.frequency == 'yearly') {
        year =  event.period;
    }

    let after = `${year}-01-01`;
    let before = `${year}-12-31`;

    if(month) {
      before = this.datePipe.transform(new Date(year, month, 0), 'yyyy-MM-dd') as string;
      after = this.datePipe.transform(new Date(year, month - 1, 1), 'yyyy-MM-dd') as string;
    }

    this.filter.date("date", before, "before");
    this.filter.date("date", after, "after");

    if(event.unit) {
      this.filter.filter('unit', event.unit);
    } else {
      this.filter.clearFilter('unit');
    }

    if (event.split != 'all') {
      this.filter.filter('split', event.split);
    } else {
      this.filter.clearFilter('split');
    }

    let filter  = this.filter.convertFilterInQuery();


    this.professionalTransfersService.getTotalValueCards(filter).subscribe({
      next: (res) => { this.patchTotalValue(res) },
      error: (err: any) => { console.log('Erro ao carregar dados: ', err) }
    })

    this.loadProfessionalListData();

    this.loadChartData(filter);
  }

  loadProfessionalListData() {
     this.loadingProfessionals = true;
    this.professionalTransfersService.getProfessionalListData(this.filter.convertFilterInQuery()).subscribe({
      next: (res: any) => { this.patchProfessionalList(res) },
      error: (err: any) => { console.log('Erro ao carregar dados: ', err) }
    });

    let filter = new Filter();
    filter.filters = [...this.filter.filters];
    filter.filter('total', 1);
    this.professionalTransfersService.getProfessionalListData(filter.convertFilterInQuery()).subscribe({
      next: (res: any) => { this.patchTotalInProfessionalList(res[0]) },
      error: (err: any) => { console.log('Erro ao carregar dados: ', err) }
    })
  }

  openReportByProfessional(name: string, professionalId: any) {
    let before = this.filter.getFilterValue('date[before]');
    let after = this.filter.getFilterValue('date[after]');
    let unit = this.filter.getFilterValue('unit');
    let dateBeforeFormat = FormatDateUtil.formatDateString(before as string);
    let dateAfterFormat = FormatDateUtil.formatDateString(after as string);
    let title = `Relatório ${name} de ${dateAfterFormat} a ${dateBeforeFormat}`;
    this.modalService.show(ProfessionalTransfersModalComponent, title, { unit, before, after, id: professionalId, queryParams: this.filter.convertFilterInQuery(), name })
  }

  patchTotalValue(apiData: any) {
    this.loadingTotalAmount = false;
    this.form.patchValue({
      faturamento_total: apiData.revenueTotalAmount,
      receita_profissional: apiData.effectiveProfessionalAmount,
      receita_empresa: apiData.effectiveClinicAmount,
    })
  }

  patchProfessionalList(apiData: any) {
    this.loadingProfessionals = false;
    this.form.patchValue({
      listagem_profissionais: apiData
    })

    if (this.form.value.listagem_profissionais?.length) {
      this.showProfessionalList = true
    } else {
      this.showProfessionalList = false
    }

  }

  patchTotalInProfessionalList(apiData: any) {
    this.form.patchValue({
      total_listagem_profissionais: apiData
    })
  }

  onFilterChange(event: any) {
    event.forEach((e: any) => {
      this.filter.setFilter(e.key, e.filter);
    });
    this.loadProfessionalListData();
  }

  formatChartData(apiData: any) {
    this.loadingChart = false;
    apiData.reverse()
    let chartLabel = apiData.map((obj: any) => {
      return obj.month
    })

    let chartTotalData = {
      legend: "Faturamento total",
      data: apiData.map((obj: any) => { return obj.revenueTotalAmount }),
      gradientColors: [
        "rgba(0, 160, 0, 1)",
        "rgba(255, 255, 255, 0)"
      ]
    }

    let chartUnitsData = {
      legend: "Ganho da Empresa",
      data: apiData.map((obj: any) => { return obj.estimatedClinicAmount }),
      gradientColors: [
        "rgba(255, 131, 33, 1)",
        "rgba(255, 255, 255, 0)"
      ]
    }

    let chartProfessionalsData = {
      legend: "Ganho do Profissional",
      data: apiData.map((obj: any) => { return obj.estimatedProfessionalAmount }),
      gradientColors: [
        "rgba(0, 74, 160, 1)",
        "rgba(255, 255, 255, 0)"
      ]
    }

    this.form.patchValue({
      chart_data: [chartTotalData, chartProfessionalsData, chartUnitsData],
      chart_label: chartLabel
    });
    this.showChart = true;
  }

  loadChartData(queryParam?: string) {
    this.loadingChart = true;
    this.professionalTransfersService.getChartData(queryParam).subscribe({
      next: (res: any) => { this.formatChartData(res) },
      error: (err: any) => { console.log('Erro ao carregar dados: ', err), this.loadingChart = false }
    })
  }
}
